import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

let abortControllerFetchCategories = null;

/**
 * Gọi API lấy danh sách danh mục sản phẩm
 */
export const fetchCategories = createAsyncThunk(
  'get/sale_products/v3/list_categories',
  async (_, { dispatch }) => {
    try {
      if (abortControllerFetchCategories) {
        abortControllerFetchCategories.abort();
      }
      abortControllerFetchCategories = new AbortController();

      const res = await callApi({
        endpoint: 'sale_products/v3/list_categories',
        method: 'get',
        signal: abortControllerFetchCategories.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
